import RemediationPanel from 'common/components/RemediationPanel';
import { Markdown, Stack, Typography } from 'common/design-system/components-v2';
import { getK8sNamespace } from 'modules/workloads/initialize.i18n';
import { useTranslation } from 'react-i18next';
import { customizeComponents } from '../AwpHostConfigRuleDrawer.styles';
import { useRuleContext } from '../context/Rule/useRuleContext.hook';

const Remediation = () => {
    const {
        data: {
            rule: { remediation },
        },
    } = useRuleContext();
    const { t } = useTranslation(getK8sNamespace('cis'), { keyPrefix: 'sections' });
    if (!remediation) {
        return null;
    }
    return (
        <Stack spacing={4}>
            <Typography variant='bodyLg'>{t('remediation')}</Typography>
            <RemediationPanel remediation=''>
                <Stack fullWidth direction='column' spacing={2}>
                    <Markdown markdown={remediation} customizeComponents={customizeComponents} />
                </Stack>
            </RemediationPanel>
        </Stack>
    );
};

export default Remediation;
